export default __webpack_public_path__ + "static/media/profile.806941c4.jpg";